import { z } from "zod/v4";
import { CreatedAt, UpdatedAt } from "../system";
import { BrandId, BrandIdSchema } from "../../id";
import { DocumentSnapshotLike } from "../../firestore";
import { DocumentStatus } from "../../common"
import { validateUserFreeInputText } from "../../user-free-input-text-constraint"

export const BrandDenormalized = z.object({
  id: BrandIdSchema,
  name: z.string().describe("ブランド名"),
  publisher: z.string().describe("版元"),
  created_at: CreatedAt,
  updated_at: UpdatedAt,
}).describe("非正規化されたブランドの情報。更新直後は古い情報が入っているので注意。")

export const BrandDocumentMeta = z.object({
  name: validateUserFreeInputText({minLength: 1, maxLength: 50}).describe("ブランド名"),
  publisher: validateUserFreeInputText({minLength: 1, maxLength: 30}).describe("版元"),
  status: DocumentStatus,
  planning_management_id: z.string().nullable().describe("企画管理用の Uniq ID（管理番号）。最大12文字。AES-CBC で暗号化された文字列が格納される。").optional(),
  planning_name: z.string().nullable().describe("企画管理用名称。最大50文字。AES-CBC で暗号化された文字列が格納される。").optional(),
})

export type CreateBrandRequest = z.infer<typeof CreateBrandRequest>
export const CreateBrandRequest = BrandDocumentMeta

export type UpdateBrandRequest = z.infer<typeof UpdateBrandRequest>
export const UpdateBrandRequest = BrandDocumentMeta


export const BrandDocumentBody = z.intersection(
  BrandDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export const BrandDocument = z.intersection(
  BrandDocumentBody,
  z.object({
    id: BrandIdSchema,
  })
)

export type BrandDocument = z.infer<typeof BrandDocument>

export class BrandDocuments {

  static toDocumentData(doc: BrandDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    };
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): BrandDocument | null {
    if (!doc) {
      return null;
    }
    const data = doc.data();
    if (data === undefined) {
      return null;
    }

    return {
      id: BrandId(doc.id),
      name: data["name"],
      publisher: data["publisher"],
      status: data["status"],
      planning_management_id: data["planning_management_id"] ?? null,
      planning_name: data["planning_name"] ?? null,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
